import axios from 'axios';
const state = {
    visitors:[],
    total_visitors:0,
    total_new_visitors:0
};
const getters = {
    StateVisitors: state => state.visitors,
    StateTotalVisitors: state => state.total_visitors,
    StateTotalNewVisitors: state => state.total_new_visitors
};
const actions = {
    async getVisitors({commit},params){
        let siteId = this.getters.StateSiteSeleted,
            token = this.getters.StateToken,
            dates = params.dates,
            lead_id = params.lead_id;

        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
        let service = null;
        service = `visualvisitor/data/${siteId}/${dates.join('/')}`;
        if(lead_id!==null)
            service = service+"/"+lead_id;
        
        let response = await axios.get(service);
        await commit('setVisitors', response.data.data.leadsOutbound);
        await commit('setTotalVisitors',response.data.data.totalLeadsOutbound);
        await commit('setTotalNewVisitors',response.data.data.totalNewLeadsOutbound);
        return true;
    },
    async saveExtraVisitors({commit},extrafields){
        const token = this.getters.StateToken;
        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
        
        if(extrafields.get('save_history')==="true"){
            const user = this.getters.StateUser;
            extrafields.append('admin_id',user.id);
            extrafields.append('site_id',this.getters.StateSiteSeleted);
        }
        
        const response = await axios.post(`visualvisitor_extras/save`,extrafields);
        const visualvisitor_extra_id = response.data.data.visualvisitor_extra_id;
        return visualvisitor_extra_id;
    }
};
const mutations = {
    setVisitors(state,visitors){
        state.visitors = visitors;
    },
    setTotalVisitors(state,total_visitors){
        state.total_visitors = total_visitors;
    },
    setTotalNewVisitors(state,total_new_visitors){
        state.total_new_visitors = total_new_visitors;
    }
};
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/visitors.js